import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var RewardIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M7,13h3a1,1,0,0,1,1,1v6a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V13A0,0,0,0,1,7,13Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M14,13h3a0,0,0,0,1,0,0v7a1,1,0,0,1-1,1H14a1,1,0,0,1-1-1V14A1,1,0,0,1,14,13Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M2.77,10.77h5.5a0,0,0,0,1,0,0v1a0,0,0,0,1,0,0H2.77a.5.5,0,0,1-.5-.5v0A.5.5,0,0,1,2.77,10.77Z",
    transform: "translate(9.51 -0.42) rotate(45)"
  }), /*#__PURE__*/_jsx("path", {
    d: "M16.23,10.77h5.5a0,0,0,0,1,0,0v1a0,0,0,0,1,0,0h-5.5a.5.5,0,0,1-.5-.5v0A.5.5,0,0,1,16.23,10.77Z",
    transform: "translate(39.95 5.99) rotate(135)"
  }), /*#__PURE__*/_jsx("rect", {
    x: "11.5",
    y: "8",
    width: "1",
    height: "4",
    rx: "0.5"
  }), /*#__PURE__*/_jsx("path", {
    d: "M12,6.16l1.13.69a.12.12,0,0,0,.17-.12L13,5.44l1-.86a.11.11,0,0,0-.06-.19l-1.31-.11-.52-1.21a.11.11,0,0,0-.2,0l-.51,1.21-1.31.11a.11.11,0,0,0-.07.19l1,.86-.3,1.29a.11.11,0,0,0,.17.12Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M8.93,7.09l-.11.06-.35.14-.33.15-.46.18h0v0l-.19.44-.14.34-.15.36,0,.12a.12.12,0,0,1-.21,0l-.05-.12-.16-.36-.14-.34-.19-.44v0h0l-.43-.18-.36-.16-.35-.14-.11-.06a.1.1,0,0,1,0-.2l.11-.06.35-.14.33-.15.46-.18h0v0l.2-.46.14-.33.15-.35.05-.12a.12.12,0,0,1,.21,0l0,.12.16.35.14.33.19.46v0l0,0,.46.18.33.15.35.14.11.06A.1.1,0,0,1,8.93,7.09Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M18.93,7.09l-.11.06-.35.14-.33.15-.46.18h0v0l-.19.44-.14.34-.15.36-.05.12a.12.12,0,0,1-.21,0l0-.12-.16-.36-.14-.34-.19-.44v0h0l-.43-.18-.36-.16-.35-.14-.11-.06a.1.1,0,0,1,0-.2l.11-.06.35-.14.33-.15.46-.18h0v0l.2-.46.14-.33.15-.35,0-.12a.12.12,0,0,1,.21,0l0,.12.16.35.14.33.19.46v0l0,0,.46.18.33.15.35.14.11.06A.1.1,0,0,1,18.93,7.09Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M9,12H9a.5.5,0,0,1-.56-.44h0c-.07-.73-.16-1.45-.3-2.17v0a.52.52,0,0,1,.43-.57h0a.5.5,0,0,1,.56.44l0,.17c.11.59.19,1.19.25,1.79l0,.24A.52.52,0,0,1,9,12Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M14.89,12h0a.5.5,0,0,0,.56-.43h0a20,20,0,0,1,.3-2.18v0a.5.5,0,0,0-.43-.57h0a.5.5,0,0,0-.56.43l0,.17a15.58,15.58,0,0,0-.25,1.8l0,.23A.5.5,0,0,0,14.89,12Z"
  })]
}), 'RewardIcon');